import React from 'react';

/**
 * QuestionViewport
 * Fixed-height viewport that hosts the question track.
 * Height is driven by CSS variable --rms-viewport-height set by useLayoutMetrics.
 * Native scrolling is disabled via overflow hidden and .no-scrollbar.
 */
export default function QuestionViewport({ viewportRef, className = '', style = {}, children }) {
  return (
    <div
      ref={viewportRef}
      className={`no-scrollbar ${className}`}
      style={{
        height: 'var(--rms-viewport-height)',
        overflow: 'hidden',
        position: 'relative',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

